import React, { useEffect, useState } from 'react'
import styled from "styled-components";
import UserIdenticon from '../../commons/UserIdenticon';
import { getEllipsisTxt, getSliceLongTxt } from '../../../helpers/formatters';
import axios from 'axios';
import { Link } from '@reach/router';
import { useMoralis } from 'react-moralis';
import { configs } from '../../../configs/web3.config';

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
`;

export default function ModerateNFTContainer(props) {

  const { data } = props
  const { Moralis, isInitialized } = useMoralis()
  const [nftImage, setNftImage] = useState('')
  const [isNftImageLoading, setIsNftImageLoading] = useState(false)
  const [nftTitle, setNftTitle] = useState('~')
  const [nftTokenId, setNftTokenId] = useState('~')
  const [nftSellingPrice, setNftSellingPrice] = useState('')

  const [isLoadingProfile, setIsLoadingProfile] = useState(false)
  const [profileData, setProfileData] = useState({})

  const getUsername = (moralisAttributes) => {

    if (moralisAttributes) {
      if ("username" in moralisAttributes && moralisAttributes.username !== "") {
        return getSliceLongTxt(moralisAttributes.username, 40)
      } else {
        return getEllipsisTxt(data.seller, 7)
      }
    } else {
      return getEllipsisTxt(data.seller, 7)
    }
  }

  const getUserImage = (moralisAttributes, imageSize = 50) => {

    if (moralisAttributes) {
      if ("profileImageCID" in moralisAttributes && moralisAttributes.profileImageCID != null) {
        const profileImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${moralisAttributes.profileImageCID}`
        return <img className="profile-image" src={profileImageUrl} alt="" />
      } else {
        return <UserIdenticon size={imageSize} walletAddress={moralisAttributes.walletAddress} customCss={{ width: '50px', height: '50px' }} />
      }
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      if (isInitialized) {
        setIsLoadingProfile(true)
        const params = { walletAddress: data.seller };
        const profileDataResponse = await Moralis.Cloud.run("getCreatorDetailsByAddress", params);
        setProfileData(profileDataResponse)
        setIsLoadingProfile(false)
      }
    } catch (error) {
      setIsLoadingProfile(false)
      setProfileData({})
      console.error("MORALIS : error while fetching profile data ", error)

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  const saveNFTMetadataInDataBase = async (nftData, metadata) => {
    try {
      if (isInitialized) {
        //find the nft by nft data
        const CreatedMarketplaceItems = Moralis.Object.extend("MarketplaceItems")
        const query = new Moralis.Query(CreatedMarketplaceItems)
        query.equalTo('transaction_hash', nftData.transaction_hash)
        const nftResult = await query.find()

        if (nftResult && nftResult.length > 0) {
          const nft = nftResult[0]
          nft.set('nftName', metadata.name || '')
          nft.set('nftDescription', metadata.description || '')
          await nft.save()
        }
      }
    } catch (error) {
      console.error("MORALIS : error while updating the nft metadata to the database ", error)
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {



    const { web3Config } = configs

    if (isInitialized) {
      setIsNftImageLoading(true)
      const priceFormatted = parseInt(data.price) / (10 ** 18)
      setNftSellingPrice(priceFormatted.toFixed(3))
      const options = { address: data.nftContract, token_id: data.tokenId, chain: web3Config.moralisChainId }
      const tokenIdMetadata = await Moralis.Web3API.token.getTokenIdMetadata(options)
      setNftTokenId(tokenIdMetadata.token_id)
      if (tokenIdMetadata.metadata) {
        const metadata = JSON.parse(tokenIdMetadata.metadata)
        if (!data.nftName) {
          await saveNFTMetadataInDataBase(data, metadata)
        }
        let processedImageUrl = ''
        if (metadata.image.includes('ipfs://')) {
          const imageUrl = metadata.image.split('ipfs://')
          processedImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${imageUrl[1]}`
        } else {
          processedImageUrl = metadata.image
        }
        setNftImage(processedImageUrl)
        setNftTitle(metadata.name)
        setIsNftImageLoading(false)
      } else {
        setIsNftImageLoading(true)
        if (tokenIdMetadata.token_uri) {
          const response = await axios.get(tokenIdMetadata.token_uri)
          if (response.status === 200) {
            const metadata = response.data
            if (!data.nftName) {
              await saveNFTMetadataInDataBase(data, metadata)
            }
            let processedImageUrl = ''
            if (metadata.image.includes('ipfs://')) {
              const imageUrl = metadata.image.split('ipfs://')
              processedImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${imageUrl[1]}`
            } else {
              processedImageUrl = metadata.image
            }
            setNftImage(processedImageUrl)
            setNftTitle(metadata.name)

          }
        } else {
          setNftImage('')
          setNftTitle('~')
        }
        setIsNftImageLoading(false)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  return (
    <div className="nft__item">
      {
        isLoadingProfile ?
          (
            <div className="de_countdown">
              <div className="spinner-grow spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>

          ) :
          (
            <div className="de_countdown">

              <Link to={`/creator-profile/${profileData && profileData.attributes ? profileData.attributes.walletAddress : ''}`}>
                <span >{getUsername(profileData ? profileData.attributes : null)}</span>
              </Link>
            </div>
          )
      }

      <div className='nft-clickable-container'>
        <Link to={`/moderate-nft/${data.nftContract}/token-id/${data.tokenId}/item-id/${data.itemId}`}>
          <div className="author_list_pp">
            <span onClick={() => console.log("sell your nft")}>
              {getUserImage(profileData.attributes, 50)}
              <i className="fa fa-check"></i>
            </span>
          </div>
          <div className="nft__item_wrap" style={{ height: `${302}px` }}>
            {
              isNftImageLoading ? (
                <div className="spinner-grow spinner-grow-sm" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                <Outer>
                  <span onClick={() => console.log("sell your nft")}>
                    <img src={nftImage} className="lazy nft__item_preview" alt="" />
                  </span>
                </Outer>
              )
            }
          </div>
          <div className="nft__item_info">
            <span>
              <h4>{getSliceLongTxt(nftTitle, 30)}</h4>
              <span>Token ID : # {nftTokenId || '~'}</span>
            </span>

            <div className="nft__item_price">
              {nftSellingPrice} BNB
            </div>
            <div className="list-nft-btn mb-3">
              <span>Moderate NFT </span>
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}
